// src/hooks/useNotificaciones.js
import { useEffect } from "react";

export function useNotificaciones(cotizaciones) {
  useEffect(() => {
    if (!cotizaciones?.length) return;
    if (!("Notification" in window)) return;
    if (Notification.permission === "denied") return;

    const hoy = new Date(); hoy.setHours(0, 0, 0, 0);

    function parsearLocal(str) {
      if (!str) return null;
      const [y, m, d] = String(str).split("-").map(Number);
      return new Date(y, m - 1, d);
    }

    const ESTADOS_INACTIVOS = ["Ganada", "Cerrada", "Aprobada", "Perdida", "Rechazada", "Vencida"];

    const vencidas = cotizaciones.filter(c => {
      if (!c.proximoSeguimiento || ESTADOS_INACTIVOS.includes(c.estado)) return false;
      return parsearLocal(c.proximoSeguimiento) < hoy;
    });

    const proximas = cotizaciones.filter(c => {
      if (!c.proximoSeguimiento || ESTADOS_INACTIVOS.includes(c.estado)) return false;
      const diff = Math.round((parsearLocal(c.proximoSeguimiento) - hoy) / 86400000);
      return diff === 0 || diff === 1;
    });

    if (vencidas.length === 0 && proximas.length === 0) return;

    // Solo mostrar una vez por día
    const sessionKey = `notif_${new Date().toDateString()}`;
    if (sessionStorage.getItem(sessionKey)) return;

    const mostrar = () => {
      if (vencidas.length > 0) {
        new Notification("⚠ PROVEXO+ CRM — Seguimientos vencidos", {
          body: `Tienes ${vencidas.length} seguimiento${vencidas.length > 1 ? "s" : ""} vencido${vencidas.length > 1 ? "s" : ""} sin atender.`,
          icon: "/logo192.png",
          tag: "vencidos",
        });
      }
      if (proximas.length > 0) {
        setTimeout(() => {
          new Notification("📅 PROVEXO+ CRM — Seguimientos hoy/mañana", {
            body: `Tienes ${proximas.length} seguimiento${proximas.length > 1 ? "s" : ""} programado${proximas.length > 1 ? "s" : ""} para hoy o mañana.`,
            icon: "/logo192.png",
            tag: "proximos",
          });
        }, 2000);
      }
      sessionStorage.setItem(sessionKey, "1");
    };

    if (Notification.permission === "granted") {
      mostrar();
    } else if (Notification.permission === "default") {
      // Pedir permiso solo después de una interacción (evitar bloqueo automático)
      const pedirPermiso = () => {
        Notification.requestPermission().then(perm => {
          if (perm === "granted") mostrar();
        });
        document.removeEventListener("click", pedirPermiso);
      };
      document.addEventListener("click", pedirPermiso, { once: true });
    }
  }, [cotizaciones]);
}
